/**
 * Intestazione di colonna che ordina la tabella al clic. Quando il contenuto
 * e un'icona, `etichetta` da il nome della colonna a chi non la vede.
 */

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Ordinabile({
  attiva,
  verso,
  onClick,
  etichetta,
  children,
}: {
  attiva: boolean;
  verso: 'asc' | 'desc';
  onClick: () => void;
  etichetta?: string;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={etichetta}
      aria-sort={attiva ? (verso === 'asc' ? 'ascending' : 'descending') : undefined}
      className={cn('whitespace-nowrap font-medium', attiva && 'underline underline-offset-4')}
    >
      {children}
      {attiva ? (verso === 'asc' ? ' ↑' : ' ↓') : ''}
    </button>
  );
}
